module.exports = __webpack_public_path__ + "img/dock64_ua.58d0e74c.webp";